import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables"; 
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Box from '@mui/material/Box';    
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';   
import SearchIcon from '@mui/icons-material/Search'; 
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { helpHttp } from "service/HelpHttp";
import { NumericFormat } from 'components/utils/NumericFormat'; 
import { warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css"; 
import PropTypes from 'prop-types'; 
 
const initialArticlesToSelect = {
  "id": 0,
  "indexrowarticle":0, 
  "defaultStore_id": 0,
  "tradename": "",
  "substore_id": 0,
  "substore_name": "",
  "purchase_id":0,
  "article_id":0,
  "article_code": "",
  "article_namees": "",
  "article_nameen": "",
  "applytypesofsize":false,
  "applycolor":false,
  "applynumserial":false,
  "isnewpiece":true,
  "typeofsize_id":0,
  "typeofsize_namees": "",
  "typeofsize_nameen": "",
  "typeofsize_symbolsizes": "",
  "articlecolor_id":0,
  "articlecolor_namees": "",
  "articlecolor_nameen": "",
  "articlecolor_codehex": "",
  "serialnumber_id":0,
  "serialnumber":"",
  "line_description": "",
  "datepurchase": null,
  "amount": 1,
  "estimatedprice": 0, 
  "discount":0,
  "tax":0,
  "taxincluded":false, 
  "total":0, 
}; 

const initialColorToSelect= [{
  "id" : 0,
  "article_id": 0,
  "enablecolorarticle":true,
  "articlecolor_id": 0,
  "articlecolor_namees" : "",
  "articlecolor_nameen" : "",
  "articlecolor_codehex":""
}];

const initialTypesOfSizeToSelect = [{
  "id" : 0,
  "article_id": 0,
  "enabletypesofsizearticle":true,
  "articlesize_id": 0,
  "articlesize_namees" : "",
  "articlesize_nameen" : "",
  "articlesize_symbolsizes":""
}];

const initialSerialNumbersToSelect = [{
  "id": 0,
  "article_id": 0,
  "store_id": 0,
  "store_name": 0,
  "substore_id": 0,
  "substore_name": "",
  "typeofsize_id": 0,
  "typeofsize_namees": "",
  "typeofsize_nameen": "",
  "typeofsize_symbolsizes": "", 
  "color_id": 0,
  "color_namees": "",
  "color_nameen": "",
  "color_codehex": "",
  "serialnumber": ""
}];

const PurchaseSelectArticle = ({
  newArticle, 
  setNewArticle,
  errorNewArticle, 
  setErrorNewArticle,
  foundArticle, 
  setFoundArticle,
  foundNumSerial, 
  setFoundNumSerial,
  colorToSelect,
  setColorToSelect,
  typesOfSizeToSelect,
  setTypesOfSizeToSelect,
  serialNumbersToSelect,
  setSerialNumbersToSelect,
  formPurchaseDelivery,
  setFormPurchaseDelivery, 
  setShowModalSearchArticles,
  typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']); 
  const token = useSelector((state) => state.loginUser.token);  
    
  const dispatch = useDispatch();

  const handleCloseDataEditPurchaseLine = () => {
    setNewArticle(initialArticlesToSelect);
    setErrorNewArticle({});
    setFoundArticle(false);
    setFoundNumSerial(false);
    setColorToSelect(initialColorToSelect);
    setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
    setSerialNumbersToSelect(initialSerialNumbersToSelect);
  };
     
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 1000000) return true;
    return false;
  };

    const withValueCap2 = (inputObj) => {
    const { value } = inputObj;
    if (value <= 100) return true;
    return false;
  };

  const handleSearchArticle = () => {
    setShowModalSearchArticles(true); 
  }; 

  const handleChangeNewArticle = (e) => {
    const { name, value } = e.target;
    setNewArticle(newArticle => ({
      ...newArticle,
      [name]: value,
    }));
  };

  const handleBlurNewArticle = (e) => {
    handleChangeNewArticle(e);
    setErrorNewArticle(validateNewArticle());
  }; 

  const handleBlurNewArticlesAmount = (value, row) => {
    handleChangeArticlesAmount(value, row);
  };

  const handleChangeArticlesAmount = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    let totalValue=(newValue*newArticle.estimatedprice)*(1-(newArticle.discount/100))*(newArticle.taxincluded?1:(1+(newArticle.tax/100)));
    setNewArticle(newArticle => ({
      ...newArticle,
      amount:newValue,
      total:totalValue
    })); 
     setErrorNewArticle(validateNewArticle());
  }; 

  const handleBlurNewArticlesEstimatedprice = (value, row) => {
    handleChangeArticleEstimatedprice(value, row);
  };

  const handleChangeArticleEstimatedprice = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    let totalValue=(newArticle.amount*newValue)*(1-(newArticle.discount/100))*(newArticle.taxincluded?1:(1+(newArticle.tax/100)));
    setNewArticle(newArticle => ({
      ...newArticle,
      estimatedprice:newValue,
      total:totalValue
    })); 
     setErrorNewArticle(validateNewArticle());
  }; 

  const handleBlurArticlesDiscount = (value, row) => {
    handleChangeArticlesDiscount(value, row);
  };

  const handleChangeArticlesDiscount = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    let totalValue=(newArticle.amount*newArticle.estimatedprice)*(1-(newValue/100))*(newArticle.taxincluded?1:(1+(newArticle.tax/100)));
    setNewArticle(newArticle => ({
      ...newArticle,
      discount:newValue,
      total:totalValue
    })); 
     setErrorNewArticle(validateNewArticle());
  }; 

  const handleBlurArticlesTax = (value, row) => {
    handleChangeArticlesTax(value, row);
  };

  const handleChangeArticlesTax = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    let totalValue=(newArticle.amount*newArticle.estimatedprice)*(1-(newArticle.discount/100))*(newArticle.taxincluded?1:(1+(newValue/100)));
    setNewArticle(newArticle => ({
      ...newArticle,
      tax:newValue,
      total:totalValue
    })); 
    setErrorNewArticle(validateNewArticle());
  }; 

  const handleChangeTaxIncluded = (e) => {
    let newValue=!newArticle.taxincluded;
    let totalValue=(newArticle.amount*newArticle.estimatedprice)*(1-(newArticle.discount/100))*(newValue?1:(1+(newArticle.tax/100)));
      setNewArticle(newArticle => ({
      ...newArticle,
      taxincluded: !newArticle.taxincluded,
      total:totalValue
    }));
  }; 

  const handleBlurSelectColor= (e) => {
    handleChangeSelectColor(e);
    setErrorNewArticle(validateNewArticle());
  };

  const handleChangeSelectColor = (event) => { 
    if (event.target.value!==""){
      setNewArticle(newArticle => ({
        ...newArticle,
        articlecolor_id:event.target.value,
        articlecolor_namees:colorToSelect.find((key=>key.id===Number(event.target.value))).articlecolor_namees,
        articlecolor_nameen:colorToSelect.find((key=>key.id===Number(event.target.value))).articlecolor_nameen,
        articlecolor_codehex:colorToSelect.find((key=>key.id===Number(event.target.value))).articlecolor_codehex
      }));
    }
  };

  const handleBlurSelectTypeOfSizes= (e) => {
    handleChangeSelectTypeOfSizes(e);
    setErrorNewArticle(validateNewArticle());
  };

  const handleChangeSelectTypeOfSizes = (event) => { 
    if (event.target.value!==""){
      setNewArticle(newArticle => ({
        ...newArticle,
        typeofsize_id:event.target.value,
        typeofsize_namees:typesOfSizeToSelect.find((key=>key.id===Number(event.target.value))).articlesize_namees,
        typeofsize_nameen:typesOfSizeToSelect.find((key=>key.id===Number(event.target.value))).articlesize_nameen,
        typeofsize_symbolsizes:typesOfSizeToSelect.find((key=>key.id===Number(event.target.value))).articlesize_symbolsizes
      }));
    }
  };

  const handleBlurSelectSerialNumbers= (e) => {
    handleChangeSelectSerialNumbers(e);
    setErrorNewArticle(validateNewArticle());
  };
 
  const handleChangeSelectSerialNumbers = (event) => {
    const selected = serialNumbersToSelect.find(
      o => o.id === Number(event.target.value)
    );
    if (!selected) return;

    setNewArticle(prev => ({
      ...prev, //
      typeofsize_id: selected.typeofsize_id && typesOfSizeToSelect.find((key=>key.articlesize_id===Number(selected.typeofsize_id))).id,
      typeofsize_namees: selected.typeofsize_id && typesOfSizeToSelect.find((key=>key.articlesize_id===Number(selected.typeofsize_id))).typeofsize_namees,
      typeofsize_nameen: selected.typeofsize_id && typesOfSizeToSelect.find((key=>key.articlesize_id===Number(selected.typeofsize_id))).typeofsize_nameen,
      typeofsize_symbolsizes: selected.typeofsize_id && typesOfSizeToSelect.find((key=>key.articlesize_id===Number(selected.typeofsize_id))).typeofsize_symbolsizes,
      articlecolor_id: selected.color_id && colorToSelect.find((key=>key.articlecolor_id===Number(selected.color_id))).id,
      articlecolor_namees: selected.color_id && colorToSelect.find((key=>key.articlecolor_id===Number(selected.color_id))).articlecolor_namees,
      articlecolor_nameen: selected.color_id && colorToSelect.find((key=>key.articlecolor_id===Number(selected.color_id))).articlecolor_nameen,
      articlecolor_codehex: selected.color_id && colorToSelect.find((key=>key.articlecolor_id===Number(selected.color_id))).articlecolor_codehex,
      serialnumber: selected.serialnumber
    }));
  };

  const openModalDeleteRowArticle = () => {
    setNewArticle(newArticle => ({
      ...newArticle,
      id: 0,
      indexrowarticle:0, 
      purchase_id:0,
      article_id:0,
      article_code: "",
      article_namees: "",
      article_nameen: "",
      applytypesofsize:false,
      applycolor:false,
      applynumserial:false,
      isnewpiece:true,
      typeofsize_id:0,
      typeofsize_namees: "",
      typeofsize_nameen: "",
      typeofsize_symbolsizes: "",
      articlecolor_id:0,
      articlecolor_namees: "",
      articlecolor_nameen: "",
      articlecolor_codehex: "",
      serialnumber_id:0,
      serialnumber:"",
      line_description: "",
      datepurchase: null,
      amount: 1,
      estimatedprice: 0, 
      discount:0,
      tax:0,
      taxincluded:false, 
      total:0
    }));
    setFoundArticle(false);
    setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
    setColorToSelect(initialColorToSelect);
    setSerialNumbersToSelect(initialSerialNumbersToSelect);
    setErrorNewArticle(validateNewArticle());
  };

  const handleAddArticle = () => {
    const errors = validateNewArticle();
    setErrorNewArticle(errors);
    if ((Object.keys(errors).length === 0) 
        && newArticle.article_code!==undefined
        && newArticle.article_code!==null
        && newArticle.article_code!==""
       ) {
        let totalValue=(newArticle.amount*newArticle.estimatedprice)*(1-(newArticle.discount/100))*(newArticle.taxincluded?1:(1+(newArticle.tax/100)));
                   
       let articleToAdd = {
          "id": 0,
          "indexrowarticle":formPurchaseDelivery.linespurchasedelivery.length>0?formPurchaseDelivery.linespurchasedelivery[formPurchaseDelivery.linespurchasedelivery.length-1].indexrowarticle+1:1,       
          "defaultStore_id": formPurchaseDelivery.defaultStore_id,
          "tradename": formPurchaseDelivery.tradename,
          "substore_id": formPurchaseDelivery.substore_id,
          "substore_name": formPurchaseDelivery.substore_name,
          "purchase_id": formPurchaseDelivery.id,
          
          "article_id": newArticle.article_id,
          "article_code": newArticle.article_code,
          "article_namees": newArticle.article_namees,
          "article_nameen": newArticle.article_nameen,
          "applytypesofsize": newArticle.applytypesofsize,
          "applycolor": newArticle.applycolor,
          "applynumserial": newArticle.applynumserial,
          "isnewpiece":newArticle.isnewpiece,
          "typeofsize_id":  newArticle.typeofsize_id,
          "typeofsize_namees": newArticle.typeofsize_namees,
          "typeofsize_nameen":  newArticle.typeofsize_nameen,
          "typeofsize_symbolsizes":  newArticle.typeofsize_symbolsizes,
          "articlecolor_id":  newArticle.articlecolor_id,
          "articlecolor_namees":  newArticle.articlecolor_namees,
          "articlecolor_nameen":  newArticle.articlecolor_nameen,
          "articlecolor_codehex":  newArticle.articlecolor_codehex,
          "serialnumber_id":  newArticle.serialnumber_id,
          "serialnumber":  newArticle.serialnumber,
          "line_description":  newArticle.line_description,
          "datepurchase": formPurchaseDelivery.datepurchase,
          "amount": newArticle.amount,
          "estimatedprice": newArticle.estimatedprice,
          "discount": newArticle.discount,
          "tax":newArticle.tax,
          "taxincluded":newArticle.taxincluded,
          "total":totalValue
      }; 
      formPurchaseDelivery.linespurchasedelivery.push(articleToAdd);
       setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
      }))
      let totalNeto=0; 
      formPurchaseDelivery.linespurchasedelivery.map((item)=>{
        return totalNeto+=item.total;
      });
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        totalNetoPurchasedelivery:totalNeto
      }));
      handleCloseDataEditPurchaseLine();
    }else{
      if (errors.article_code) {
        dispatch(warningErrorAction(t(errors.article_code)));
      } else if (errors.line_description) {
        dispatch(warningErrorAction(t(errors.line_description)));
      } else if (errors.typeofsize_id) {
        dispatch(warningErrorAction(t(errors.typeofsize_id)));
      } else if (errors.articlecolor_id) {
        dispatch(warningErrorAction(t(errors.articlecolor_id)));
      } else if (errors.serialnumber) {
        dispatch(warningErrorAction(t(errors.serialnumber)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      } 
    }   
  };
  
  const validateNewArticle = () => {
    let errorNewArticle = {}; 
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (regexInvalidCharacters.test(newArticle.article_code)) {
      errorNewArticle.article_code = 'Text_TextNoValid';
    }else{  
      if (newArticle.article_code===undefined
        || newArticle.article_code===null
        || newArticle.article_code===""
       ){
        errorNewArticle.article_code = 'Text_Articles_Code_Required';
      }else{
        if (!foundArticle){
          errorNewArticle.article_code = 'Text_Article_NotExist';
        }
      }
    } 
    if (regexInvalidCharacters.test(newArticle.line_description)) {
      errorNewArticle.line_description = 'Text_TextNoValid';
    } 
   
    if (newArticle.applytypesofsize
      && (newArticle.typeofsize_id===undefined 
      || newArticle.typeofsize_id===null 
      || newArticle.typeofsize_id==="" 
      || newArticle.typeofsize_id==="0" 
      || newArticle.typeofsize_id===0)){
        errorNewArticle.typeofsize_id = 'Text_TypesOfSizeRequired';
    }
    if (newArticle.applycolor     
      && (newArticle.articlecolor_id===undefined 
      || newArticle.articlecolor_id===null 
      || newArticle.articlecolor_id==="" 
      || newArticle.articlecolor_id==="0" 
      || newArticle.articlecolor_id===0)){
        errorNewArticle.articlecolor_id = 'Text_ColorRequired';
    }
     if (newArticle.applynumserial){
      if (newArticle.serialnumber===""  || newArticle.serialnumber===null){
        errorNewArticle.serialnumber = 'Text_NumSerialRequired';
      }else{
        if (regexInvalidCharacters.test(newArticle.serialnumber)) {
          errorNewArticle.serialnumber = 'Text_TextNoValid';
        } else{
          if (typeOfList==="1" && foundNumSerial){
          errorNewArticle.serialnumber = 'Text_NumSerial_Exist';
          }
        } 
      } 
    } 
    return errorNewArticle;
  };

  useEffect(() => {
    let isMounted = true;
    const fetchExistNumSerial = async () => {
      const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getarticlestorebynumserial/`, token,newArticle.serialnumber.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
      } else if (isMounted) {
        setFoundNumSerial(getData>0)  
      }
    };  
    if (typeOfList==="1"){
      if (newArticle.serialnumber && newArticle.serialnumber.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchExistNumSerial();
      }  
    }  
  }, [t,token,dispatch,i18n,newArticle.serialnumber,typeOfList,setFoundNumSerial]);
    
  useEffect(() => {
    let isMounted = true;
    const fetchExistArticle = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getexistarticlebycode/`,token,newArticle.article_code.replace(/[.\-/\\|]/g, ""));
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 ){
              fetchSheetByLicencePlate();
          }else{
            setNewArticle(newArticle => ({
              ...newArticle,
              article_id: 0, 
              article_namees: "",
              article_nameen: "",
              applytypesofsize:false,
              applycolor:false,
              applynumserial:false,
              isnewpiece:true,
              typeofsize_id:0,
              typeofsize_namees: "",
              typeofsize_nameen: "",
              typeofsize_symbolsizes: "",
              articlecolor_id:0,
              articlecolor_namees: "",
              articlecolor_nameen: "",
              articlecolor_codehex: "",
              serialnumber_id:0,
              serialnumber:"",
              estimatedprice: 0, 
              tax:0,
              taxincluded:false, 
              total:0
            }));
            setFoundArticle(false);
            setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
            setColorToSelect(initialColorToSelect);
            setSerialNumbersToSelect(initialSerialNumbersToSelect);
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchSheetByLicencePlate = async () => {
        try {
            const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getarticlebycode/`,token,newArticle.article_code.replace(/[.\-/\\|]/g, ""));
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                if (getData!==undefined && getData!==null && getData!==""){
                    let totalValue=((getData.applynumserial?1:newArticle.amount)*getData.estimatedprice)*(1-(newArticle.discount/100))*(getData.taxincluded?1:(1+(getData.tax/100)));
                    setNewArticle(newArticle => ({
                        ...newArticle,
                        article_id: getData.id, 
                        article_namees: getData.article_namees,
                        article_nameen: getData.article_nameen,
                        applytypesofsize: getData.applytypesofsize,
                        applycolor: getData.applycolor,
                        applynumserial: getData.applynumserial,
                        isnewpiece:getData.isnewpiece,
                        estimatedprice: getData.estimatedprice,
                        tax: getData.typesoftax_tax,
                        taxincluded: getData.typesoftax_taxinclude,
                        amount:getData.applynumserial?1:newArticle.amount,
                        total: totalValue
                    }));
                    if(getData.applytypesofsize && getData.articlesizes && getData.articlesizes.length>0){
                      setTypesOfSizeToSelect(getData.articlesizes);
                    }else{
                      setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
                    }
                    if(getData.applycolor && getData.articlecolors && getData.articlecolors.length>0){
                      setColorToSelect(getData.articlecolors);
                    }else{
                      setColorToSelect(initialColorToSelect);
                    }
                    if(getData.applynumserial && getData.articlestorenumseriales && getData.articlestorenumseriales.length>0){
                      setSerialNumbersToSelect(getData.articlestorenumseriales);
                    }else{
                      setSerialNumbersToSelect(initialSerialNumbersToSelect);
                    }
                     setFoundArticle(true);
                } else{
                   setNewArticle(newArticle => ({
                      ...newArticle,
                      article_id: 0, 
                      article_namees: "",
                      article_nameen: "",
                      applytypesofsize:false,
                      applycolor:false,
                      applynumserial:false,
                      isnewpiece:true,
                      typeofsize_id:0,
                      typeofsize_namees: "",
                      typeofsize_nameen: "",
                      typeofsize_symbolsizes: "",
                      articlecolor_id:0,
                      articlecolor_namees: "",
                      articlecolor_nameen: "",
                      articlecolor_codehex: "",
                      serialnumber_id:0,
                      serialnumber:"",
                      estimatedprice: 0, 
                      tax:0,
                      taxincluded:false, 
                      total:0
                    }));
                    setFoundArticle(false);
                    setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
                    setColorToSelect(initialColorToSelect);
                    setSerialNumbersToSelect(initialSerialNumbersToSelect);
                } 
            }         
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };
    if (newArticle.article_code && newArticle.article_code.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistArticle();
    }else{
      setNewArticle(newArticle => ({
        ...newArticle,
        article_id: 0, 
        article_namees: "",
        article_nameen: "",
        applytypesofsize:false,
        applycolor:false,
        applynumserial:false,
        isnewpiece:true,
        typeofsize_id:0,
        typeofsize_namees: "",
        typeofsize_nameen: "",
        typeofsize_symbolsizes: "",
        articlecolor_id:0,
        articlecolor_namees: "",
        articlecolor_nameen: "",
        articlecolor_codehex: "",
        serialnumber_id:0,
        serialnumber:""
      }));
      setFoundArticle(false);
      setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
      setColorToSelect(initialColorToSelect);
      setSerialNumbersToSelect(initialSerialNumbersToSelect);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,newArticle.article_code,newArticle.amount,newArticle.discount,setColorToSelect,setFoundArticle,setNewArticle,setSerialNumbersToSelect,setTypesOfSizeToSelect]);
  
  return(
     <> 
      <Box sx={{ maxWidth: 1010,backgroundColor:"#f0f0f0ff",padding:2 }}>
        <Typography style={{flex: '1 1 100%', color:"#067330", fontSize: 18}} id="tableTitle" component="div">
          {t('Text_PURCHASEDELIVERY_SELECT_ARTICLES')}&nbsp;&nbsp;
          <IconButton size="small" style={{color:"#e74a3b", fontSize: 18}} onClick={handleSearchArticle}>
            <SearchIcon sx={{ color:"#067330", fontSize: 24}}/>
          </IconButton>
        </Typography>
        <Box sx={{ maxWidth: 1010}}>
          {/* Fila 1: CÓDIGO, DESCRIPCIÓN, REFERENCIA */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '80px 1fr 1fr', md: '120px 1fr 1fr' },
              gap: 2,
              mb: 2
            }}
          >
            {/* Código (más pequeño) */}
            <TextField
              id="article_code"
              name="article_code"
              value={newArticle.article_code}
              inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
              InputLabelProps={{ style: { fontSize: 16 } }}
              label={errorNewArticle.article_code ? t(errorNewArticle.article_code) : t('Text_PURCHASEDELIVERY_ARTICLE_CODE')}
              placeholder={t('Text_PURCHASEDELIVERY_ARTICLE_CODE')}
              variant="standard"
              onBlur={handleBlurNewArticle}
              onChange={handleChangeNewArticle}
            />

            {/* Descripción (más grande) */}
            <TextField
              id="article_namees"
              name="article_namees"
              value={i18n.language==='es'?newArticle.article_namees:newArticle.article_nameen}
              inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
              InputLabelProps={{ style: { fontSize: 16 } }}
              label={t('Text_PURCHASEDELIVERY_ARTICLE_DESCRIPCIÓN')}
              placeholder={t('Text_PURCHASEDELIVERY_ARTICLE_DESCRIPCIÓN')}
              variant="standard"
              disabled
            />

            {/* Referencia (mismo tamaño que descripción) */}
            <TextField
              id="line_description"
              name="line_description"
              value={newArticle.line_description}
              inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
              InputLabelProps={{ style: { fontSize: 16 } }}
              label={errorNewArticle.line_description ? t(errorNewArticle.line_description) : t('Text_Articles_ReferenceLine')}
              placeholder={t('Text_Articles_ReferenceLine')}
              variant="standard"
              onBlur={handleBlurNewArticle}
              onChange={handleChangeNewArticle}
            />
          </Box>
          {
          (newArticle.applytypesofsize ||newArticle.applycolor || newArticle.applynumserial)  &&
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr 1fr 1fr', md: '1fr 1fr 1fr' },
                gap: 2,
                mb: 2
              }}
            >
              <TextField
                id="articlecolor_id"
                name="articlecolor_id"
                value={ (newArticle.articlecolor_id === undefined || newArticle.articlecolor_id ===null || newArticle.articlecolor_id ===""
                      || newArticle.articlecolor_id ==="0" || newArticle.articlecolor_id ===0)?0:newArticle.articlecolor_id}
                inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={errorNewArticle.articlecolor_id ? t(errorNewArticle.articlecolor_id) : t('Text_Colors_Article')}
                placeholder={t('Text_Colors_Article')}
                variant="outlined"
                onBlur={handleBlurSelectColor}
                onChange={handleChangeSelectColor}
                disabled={!newArticle.applycolor || (typeOfList==="2" && newArticle.applynumserial)}
                select
                SelectProps={{
                  native: true,
                  value: (newArticle.articlecolor_id === undefined || newArticle.articlecolor_id ===null || newArticle.articlecolor_id ===""
                      || newArticle.articlecolor_id ==="0" || newArticle.articlecolor_id ===0)?0: newArticle.articlecolor_id
                }}> 
                <option key={0} value=""/>
                {colorToSelect.map((option) => (
                <option key={option.id} value={option.id}>
                    {i18n.language==="es"?option.articlecolor_namees:option.articlecolor_nameen}
                </option>
                ))}
              </TextField>
              <TextField
                id="typeofsize_id"
                name="typeofsize_id"
                value={ (newArticle.typeofsize_id === undefined || newArticle.typeofsize_id ===null || newArticle.typeofsize_id ===""
                      || newArticle.typeofsize_id ==="0" || newArticle.typeofsize_id ===0)?0:newArticle.typeofsize_id}
                inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
                InputLabelProps={{ style: { fontSize: 16} }}
                label={errorNewArticle.typeofsize_id ? t(errorNewArticle.typeofsize_id) : t('Text_Sizes_Article')}
                placeholder={t('Text_Sizes_Article')}
                variant="outlined"
                onBlur={handleBlurSelectTypeOfSizes}
                onChange={handleChangeSelectTypeOfSizes}
                disabled={!newArticle.applytypesofsize || (typeOfList==="2" && newArticle.applynumserial)}
                select
                SelectProps={{
                  native: true,
                  value: (newArticle.typeofsize_id === undefined || newArticle.typeofsize_id ===null || newArticle.typeofsize_id ===""
                      || newArticle.typeofsize_id ==="0" || newArticle.typeofsize_id ===0)?0: newArticle.typeofsize_id
                }}> 
                <option key={0} value=""/>
                {typesOfSizeToSelect.map((option) => (
                <option key={option.id} value={option.id}>
                    {i18n.language==="es"?option.articlesize_namees:option.articlesize_nameen}
                </option>
                ))}
              </TextField>
              {typeOfList==="1"?
                <TextField
                  id="serialnumber"
                  name="serialnumber"
                  value={newArticle.serialnumber}
                  inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
                  InputLabelProps={{ style: { fontSize: 16 } }}
                  label={errorNewArticle.serialnumber ? t(errorNewArticle.serialnumber) : t('Text_NumSeriales_Article')}
                  placeholder={t('PlaceHolder_NumSeriales_Article')}
                  variant="standard"
                  onBlur={handleBlurNewArticle}
                  onChange={handleChangeNewArticle}
                  disabled={!newArticle.applynumserial}
                />
              :
                <TextField
                  id="serialnumber_id"
                  name="serialnumber_id"
                  value={
                    serialNumbersToSelect.find(
                      (o) => o.serialnumber === newArticle.serialnumber
                    )?.id ?? 0
                  }
                  inputProps={{ style: { fontSize: 18 }, maxLength: 100 }}
                  InputLabelProps={{ style: { fontSize: 16 } }}
                  variant="outlined"
                  onBlur={handleBlurSelectSerialNumbers}
                  onChange={handleChangeSelectSerialNumbers}
                  disabled={!newArticle.applynumserial}
                  select
                  SelectProps={{
                    native: true,
                    value:
                      serialNumbersToSelect.find(
                        (o) => o.serialnumber === newArticle.serialnumber
                      )?.id ?? 0,
                  }}
                >
                  <option key={0} value="" />
                  {serialNumbersToSelect
                    .filter(
                      (option) =>
                        !formPurchaseDelivery.linespurchasedelivery.some(
                          (line) =>
                            line.serialnumber === option.serialnumber 
                        )
                    )
                    .map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.serialnumber}
                      </option>
                    ))}
                </TextField>

              } 
            </Box>
          }
          {/* Fila 2: RESTO DE CAMPOS */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(6, max-content) 1fr' },
              alignItems: 'end',
              gap: 2
            }}
          >
            {/* PESO/CANT */}
            <Box>
              <Typography sx={{ color:"#4e73df", fontSize: 14, mb: 0.5 }}>
                {t('Text_PURCHASEDELIVERY_ARTICLE_AMOUNT')}
              </Typography>
              <NumericFormat
                thousandSeparator=","
                decimalSeparator="."
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={withValueCap}
                id="amount"
                name="amount"
                value={newArticle.amount}
                style={{ width: 100, color: newArticle.applynumserial?"#f5f5f5":"red", background: newArticle.applynumserial?"#bdbdbd":"black", fontSize: 20, textAlign: "right",paddingRight: 5 }}
                onBlur={(e) => handleBlurNewArticlesAmount(e.target.value)}
                onChange={(e) => handleChangeArticlesAmount(e.target.value)}
                disabled={newArticle.applynumserial}
              />
            </Box>
            {/* PRECIO */}
            <Box>
              <Typography sx={{ color:"#4e73df", fontSize: 14, mb: 0.5 }}>
                {t('Text_PURCHASEDELIVERY_ARTICLE_PRICE')}
              </Typography>
              <NumericFormat
                thousandSeparator=","
                decimalSeparator="."
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={withValueCap}
                id="estimatedprice"
                name="estimatedprice"
                value={newArticle.estimatedprice}
                suffix={" €"}
                style={{ width: 118, color: "red", background: "black", fontSize: 20, textAlign: "right", paddingRight: 5      }}
                onBlur={(e) => handleBlurNewArticlesEstimatedprice(e.target.value)}
                onChange={(e) => handleChangeArticleEstimatedprice(e.target.value)}
              />
            </Box>

            {/* DESCUENTO */}
            <Box>
              <Typography sx={{ color:"#4e73df", fontSize: 14, mb: 0.5 }}>
                {t('Text_PURCHASEDELIVERY_ARTICLE_DISCOUNT')}
              </Typography>
              <NumericFormat
                thousandSeparator=","
                decimalSeparator="."
                decimalScale={0}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={withValueCap2}
                id="discount"
                name="discount"
                value={newArticle.discount}
                suffix={" %"}
                style={{ width: 100, color: "red", background: "black", fontSize: 20, textAlign: "right",paddingRight: 5 }}
                onBlur={(e) => handleBlurArticlesDiscount(e.target.value)}
                onChange={(e) => handleChangeArticlesDiscount(e.target.value)}
              />
            </Box>
            {/* IMPUESTO */}
            <Box>
              <Typography sx={{ color:"#4e73df", fontSize: 14, mb: 0.5 }}>
                {t('Text_PURCHASEDELIVERY_ARTICLE_TAX')}
              </Typography>
              <NumericFormat
                thousandSeparator=","
                decimalSeparator="."
                decimalScale={0}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={withValueCap2}
                id="tax"
                name="tax"
                value={newArticle.tax}
                suffix={" %"}
                style={{ width: 100, color: "red", background: "black", fontSize: 20, textAlign: "right",paddingRight: 5 }}
                onBlur={(e) => handleBlurArticlesTax(e.target.value)}
                onChange={(e) => handleChangeArticlesTax(e.target.value)}
              />
            </Box>
            {/*IMPUESTO INCLUIDO */}
            <Box>
              <Typography sx={{ color:"#4e73df", fontSize: 14, mb: 0.5 }}>
                {t('Text_PURCHASEDELIVERY_ARTICLE_TAX_INCLUDED')}
              </Typography>
              <Checkbox
                id="taxincluded" 
                name="taxincluded"
                checked={newArticle.taxincluded}
                onChange={handleChangeTaxIncluded}
                variant="standard"
                sx={{
                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 },
                }}
              />
            </Box>
            {/* TOTAL (solo lectura) */}
            <Box>
              <Typography sx={{ color:"#4e73df", fontSize: 14, mb: 0.5 }}>
                {t('Text_PURCHASEDELIVERY_ARTICLE_TAX_TOTAL')}
              </Typography>
              <NumericFormat
                thousandSeparator=","
                decimalSeparator="."
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={withValueCap}
                id="total"
                name="total"
                value={newArticle.total}
                suffix={" €"}
                style={{ width: 150, color: "#f5f5f5", background: "#bdbdbd", fontSize: 20, textAlign: "right",paddingRight: 5 }}
                disabled
              />
            </Box>
            {/* Botón borrar al final de la fila */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 2,
                alignItems: "stretch"
              }}
            >
              {/* Botón Añadir */}
              <Button
                variant="contained"
                color="success"
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: 0,
                  py: 1.5 
                }}
                onClick={handleAddArticle}
                fullWidth
              >
                <AddCircleIcon sx={{ fontSize: 32 }} />
              </Button> 
              {/* Botón Borrar */}
              <Button
                variant="contained"
                color="error"
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: 0,
                  py: 1.5
                }}
                onClick={openModalDeleteRowArticle}
                fullWidth
              >
                <DeleteIcon sx={{ fontSize: 32 }} />
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

PurchaseSelectArticle.propTypes = {
  setNewArticle: PropTypes.func.isRequired,
  setErrorNewArticle: PropTypes.func.isRequired,
  setFoundArticle: PropTypes.func.isRequired,
  setFoundNumSerial: PropTypes.func.isRequired,
  setTypesOfSizeToSelect: PropTypes.func.isRequired,
  setSerialNumbersToSelect: PropTypes.func.isRequired,
  setFormPurchaseDelivery: PropTypes.func.isRequired,
  setShowModalSearchArticles: PropTypes.func.isRequired
};

export default PurchaseSelectArticle;